import React, { useState } from "react";

import AadhaarOtpStep1 from "../components/ApplyNowSteps/AadhaarOtpStep1";
import AadharFulfill1 from "../components/ApplyNowSteps/AadharFulfill1";
import LoanForm1 from "../components/ApplyNowSteps/LoanForm1";
import ThankYou1 from "../components/ApplyNowSteps/ThankYou1";
import ApplyFlowSidebar1 from "../components/ApplyNowSteps/ApplyFlowSidebar1";
import { clearFromAadhaarStep, clearLoanStepDraft, clearStep2ContactRestore, markStep2ContactRestore } from "../utils/applyFlowStorage";

import "../pages/ApplyNow.css";
import "../pages/ApplyNow1.css";

const ApplyNow1 = () => {
  const [step, setStep] = useState(1);

  const handleBackToStep1 = () => {
    clearFromAadhaarStep();
    setStep(1);
  };

  const handleBackToStep2 = () => {
    markStep2ContactRestore();
    setStep(2);
  };

  const handleEnterStep2FromAadhaar = () => {
    clearStep2ContactRestore();
    localStorage.removeItem("loanFormData");
    clearLoanStepDraft();
    setStep(2);
  };

  const handleEnterStep3FromContact = () => {
    clearLoanStepDraft();
    setStep(3);
  };

  if (step === 4) {
    return (
      <div className="apply-now1-page apply-now1-page--success">
        <div className="apply-now1-success-card">
          <ThankYou1 />
        </div>
      </div>
    );
  }

  return (
    <div className="apply-now1-page">
      <div className="apply-now1-container">
        <header className="apply-now1-header">
          <div>
            <span className="apply-now1-header__eyebrow">Digital Loan Journey</span>
            <h1>Apply Now</h1>
            <p>Fast, paper-light and secure application flow.</p>
          </div>
          <div className="apply-now1-header__meta">
            <span>Paperless</span>
            <span>OTP-secured</span>
            <span>Quick apply</span>
          </div>
        </header>

        <div className="apply-now1-content">
          <aside className="apply-now1-rail">
            <ApplyFlowSidebar1 currentStep={step} />
          </aside>

          <main className="apply-now1-workspace">
            {step === 1 && (
              <div className="apply-now1-stage apply-now1-stage--focus">
                <AadhaarOtpStep1 onNext={handleEnterStep2FromAadhaar} />
              </div>
            )}

            {(step === 2 || step === 3) && (
              <div className={`apply-now1-stage-card ${step === 3 ? "apply-now1-stage-card--scroll" : ""}`}>
                {step === 2 && (
                  <AadharFulfill1
                    onBack={handleBackToStep1}
                    onNext={handleEnterStep3FromContact}
                  />
                )}

                {step === 3 && (
                  <LoanForm1
                    onBack={handleBackToStep2}
                    onNext={() => setStep(4)}
                  />
                )}
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
};

export default ApplyNow1;
